import { request } from "./client";

export const getLeagueWaivers = (leagueId) =>
  request(`/leagues/${leagueId}/waivers`);

export const getLeagueWaiversAdmin = (leagueId) =>
  request(`/leagues/${leagueId}/waivers?all=true`);

export const getWaiver = (leagueId, waiverId) =>
  request(`/leagues/${leagueId}/waivers/${waiverId}`);

export const createWaiver = (leagueId, payload) =>
  request(`/leagues/${leagueId}/waivers`, {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const setWaiverActive = (leagueId, waiverId, isActive) =>
  request(`/leagues/${leagueId}/waivers/${waiverId}`, {
    method: "PATCH",
    body: JSON.stringify({ isActive }),
  });

export const updateWaiverContent = (leagueId, waiverId, payload) =>
  request(`/leagues/${leagueId}/waivers/${waiverId}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });

export const signWaiver = (leagueId, waiverId, payload) =>
  request(`/leagues/${leagueId}/waivers/${waiverId}/sign`, {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const getWaiverSignatures = (leagueId, waiverId) =>
  request(`/leagues/${leagueId}/waivers/${waiverId}/signatures`);

export const getSignaturePdfUploadUrl = (leagueId, waiverId, signatureId) =>
  request(`/leagues/${leagueId}/waivers/${waiverId}/signatures/${signatureId}/upload-url`, {
    method: "POST",
  });

export const getSignatureImageUploadUrl = (leagueId, waiverId, signatureId) =>
  request(`/leagues/${leagueId}/waivers/${waiverId}/signatures/${signatureId}/image-upload-url`, {
    method: "POST",
  });

export const storeSignatureKeys = (leagueId, waiverId, signatureId, keys) =>
  request(`/leagues/${leagueId}/waivers/${waiverId}/signatures/${signatureId}`, {
    method: "PATCH",
    body: JSON.stringify(keys),
  });

// Keep old name working for any callers
export const storeSignaturePdfKey = (leagueId, waiverId, signatureId, s3Key) =>
  storeSignatureKeys(leagueId, waiverId, signatureId, { s3Key });

export const getMyWaiverSignature = (leagueId, waiverId, email) => {
  const query = email ? `?email=${encodeURIComponent(email)}` : "";
  return request(`/leagues/${leagueId}/waivers/${waiverId}/my-signature${query}`);
};

export const resetMyWaiverSignature = (leagueId, waiverId, email) => {
  const query = email ? `?email=${encodeURIComponent(email)}` : "";
  return request(`/leagues/${leagueId}/waivers/${waiverId}/my-signature${query}`, {
    method: "DELETE",
  });
};
